import Vue from 'vue'
import Router from 'vue-router'
import { validateToken } from '@/api/auth'

import Layout from '@/components/Layout'
import Login from '@/views/Login'
import Tracking from '@/views/Tracking'
import Geofences from '@/components/Geofences'
import Routes from '@/components/Routes'
import Places from '@/components/Places'
import Reports from '@/views/Reports'
import Travels from '@/views/Travels'
import Profile from '@/views/Profile'
import Help from '@/views/Help'
import Guests from '@/components/Guests'
import ConfirmEmail from '@/components/ConfirmEmail'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/app/tracking'
    },
    {
      name: 'login',
      path: '/login',
      component: Login
    },
    {
      name: 'confirm-email',
      path: '/confirm-email/:token',
      component: ConfirmEmail
    },
    {
      name: 'forgot-password',
      path: '/forgot-password',
      component: ForgotPassword
    },
    {
      name: 'reset-password',
      path: '/reset-password/:token',
      component: ResetPassword
    },
    {
      path: '/app',
      component: Layout,
      children: [
        {
          name: 'tracking',
          path: 'tracking',
          component: Tracking
        },
        {
          name: 'geofences',
          path: 'geofences',
          component: Geofences
        },
        {
          name: 'routes',
          path: 'routes',
          component: Routes
        },
        {
          name: 'places',
          path: 'places',
          component: Places
        },
        {
          name: 'reports',
          path: 'reports',
          component: Reports
        },
        {
          name: 'travels',
          path: 'travels',
          component: Travels
        },
        {
          name: 'profile',
          path: 'profile',
          component: Profile
        },
        {
          name: 'help',
          path: 'help',
          component: Help
        },
        {
          name: 'guests',
          path: 'guests',
          component: Guests
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const whitelist = ['login', 'forgot-password', 'reset-password']
  const guestsBlacklist = ['guests']
  const isWithinWhitelist = whitelist.indexOf(to.name) !== -1
  if (isWithinWhitelist) return next()
  const token = localStorage.getItem('heimdall-session-token')
  if (!token) {
    localStorage.setItem('heimdall-session-last-path', to.path)
    return next('/login')
  }
  const tokenIsValid = await validateToken(token)
  if (!tokenIsValid) {
    localStorage.setItem('heimdall-session-last-path', to.path)
    return next('/login')
  }
  const sessionIsGuest = JSON.parse(localStorage.getItem('heimdall-session-is-guest'))
  if (sessionIsGuest) {
    const isWithinBlacklist = guestsBlacklist.indexOf(to.name) !== -1
    if (isWithinBlacklist) return next(false)
  }
  const lastPath = localStorage.getItem('heimdall-session-last-path')
  if (lastPath) {
    localStorage.removeItem('heimdall-session-last-path')
    return next(lastPath)
  }
  return next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js